import Vue from 'vue';

import MenuRepresentante from "@/views/menus/MenuRepresentante";
import MenuAdministrador from "@/views/menus/MenuAdministrador";
import MenuCliente from "@/views/menus/MenuCliente";
import MenuFornecedor from "@/views/menus/MenuFornecedor";
import MenuMaster from "@/views/menus/MenuMaster";


Vue.component('MenuRepresentante', MenuRepresentante);
Vue.component('MenuAdministrador', MenuAdministrador);
Vue.component('MenuCliente', MenuCliente);
Vue.component('MenuFornecedor', MenuFornecedor);
Vue.component('MenuMaster', MenuMaster);
